export const environment = {
  production: false,
  refreshTokenName: 'refreshToken_test',
  accessTokenName: 'accessToken_test',
  API_URL: 'https://nagykun-portal-storage-api-test-eud4enexgpdtgpc0.westeurope-01.azurewebsites.net/',
  WEB_URL: '',
  DOC_URL: 'https://admin-nagykun-portal.adb-pro.hu/',
  EMAIL_SERVER_ACTIVE: true,
};
